import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__inner" }
const _hoisted_2 = { class: "subscription-form" }
const _hoisted_3 = { class: "subscription-form__btn subscription-form__btn--upgrade btns btns--large" }

import { ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import { BillingView } from '@/models/billing'
import { PlanView } from '@/models/billing.plans'
import { ValidationState } from '@/helpers/form'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import BasePopup from '@/components/ui/BasePopup.vue'
import {
  PlanChangeFailedError,
  UserCancelledError,
} from '@/services/cordova.purchase.types'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChangeBillingPeriodPopup',
  props: {
    billing: {},
    targetPlan: {},
    title: {},
    confirmButtonText: {}
  },
  emits: ['subscribed'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit
const wait = useWait()

const validation = ref(new ValidationState())

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

function show(): void {
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
  validation.value.reset()
}

async function subscribe(): Promise<void> {
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.targetPlan)
    emit('subscribed')
    validation.value.reset()
    hide()
    wait.end('Subscribing')
  } catch (error) {
    wait.end('Subscribing')
    if (error instanceof UserCancelledError) {
      return
    }
    if (error instanceof PlanChangeFailedError) {
      validation.value.showError(props.targetPlan.id, error.message)
    } else {
      validation.value.showErrors(error)
    }
  }
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  const _component_v_wait = _resolveComponent("v-wait")!
  const _directive_wait = _resolveDirective("wait")!

  return (_openBlock(), _createBlock(BasePopup, {
    ref_key: "popup",
    ref: popup,
    title: __props.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("form", _hoisted_2, [
          _createVNode(_component_v_wait, { for: "Subscribing" }, {
            waiting: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, [
                _cache[0] || (_cache[0] = _createTextVNode(" Processing... ", -1)),
                _createVNode(ButtonSpinner)
              ])
            ]),
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "subscription-form__btn subscription-form__btn--upgrade btns btns--large",
                onClick: subscribe
              }, [
                _createElementVNode("span", null, _toDisplayString(__props.confirmButtonText), 1)
              ])), [
                [_directive_wait, 'Subscribing', "disabled"]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("button", {
                type: "button",
                class: "subscription-form__btn btns btns--white btns--large",
                onClick: hide
              }, [...(_cache[1] || (_cache[1] = [
                _createElementVNode("span", null, "Cancel", -1)
              ]))])), [
                [_directive_wait, 'Subscribing', "disabled"]
              ])
            ]),
            _: 1
          }),
          _createVNode(FormError, {
            errors: validation.value.errors,
            field: __props.targetPlan.id
          }, null, 8, ["errors", "field"])
        ])
      ])
    ]),
    _: 3
  }, 8, ["title"]))
}
}

})